import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { SubmitButton } from '../../foundation/form/buttons/submit-button';
import { FormContainer } from '../../foundation/layout/form-container';
import { FormField } from '../../foundation/form/form-field';
import { Box } from '@mui/material';
import { FieldWrapper } from '../../foundation/layout/field-wrapper';

export type SaveTradingTemplateFormState = {
  name: string;
};

export type SaveTradingTemplateFormProps = {
  onSubmit: (state: SaveTradingTemplateFormState) => void;
  initialValues?: Partial<SaveTradingTemplateFormState>;
  submitLabel?: string;
};

export const SaveTradingTemplateForm: FC<SaveTradingTemplateFormProps> = ({
  onSubmit,
  initialValues,
  submitLabel
}) => {
  const formApi = useForm<SaveTradingTemplateFormState>({
    defaultValues: {
      name: initialValues?.name || ''
    }
  });
  const { handleSubmit } = formApi;

  return (
    <FormProvider {...formApi}>
      <Box
        component="form"
        sx={{ height: 150 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormContainer>
          <FormField type="text" name="name" label="Name" />
          <FieldWrapper>
            <SubmitButton text={submitLabel || 'Save'} />
          </FieldWrapper>
        </FormContainer>
      </Box>
    </FormProvider>
  );
};
